

import React, { useState, useEffect } from 'react';
import { FaCircle } from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Shop.css';
import CoolBeanz from '../assets/brik.png';
import JIowef from '../assets/briksupport.jpg';
import bigphoneStand from "../assets/bigphonestand.png";
import utilityCard from "../assets/utility.png";
import knifeCard from "../assets/knife.png";
import knifeCard1 from "../assets/knifeshiv.png";
import brikCard from "../assets/brikcard.png";
import brikCard1 from "../assets/brikkycard.png";
import brikCard2 from "../assets/brikkycard1.png";
import battert from "../assets/battery.png";
import powerbank from "../assets/battery.png";
import bottle from "../assets/bottles.png";
import bottle1 from "../assets/bottles1.png";
import chapstick from "../assets/chappy.png";
import chapstick1 from "../assets/chappy1.png";

import brikwallet from "../assets/walletyuh.png";
import brikwallet1 from "../assets/walletpic.png";
import brikwallet2 from "../assets/walletpic1.png";
import brikwallet3 from "../assets/walletpic2.png";
import brikwallet4 from "../assets/walletpic3.png";
import batterypack from "../assets/batterypack.png";
import batterypack1 from "../assets/batterypack1.png";
import utilityCard1 from "../assets/utility1.png";
import phonestand from "../assets/phone1.png"
import hunting from "../assets/hunt4.png";
import hunting1 from "../assets/hunt.png";


const products = [
  {
    id: 1,
    name: 'Wallet',
    price: '$39.99',
    images: [brikwallet, brikwallet2, brikwallet4],
    link: '/wallet',
  },
  {
    id: 2,
    name: 'Phone Stand',
    price: '$12.99',
    images: [bigphoneStand, phonestand],
    link: '/stand',
  },
  {
    id: 3,
    name: 'Brik Card',
    price: '$12.99',
    images: [brikCard, brikCard1, brikCard2],
    link: '/card',
  },
  {
    id: 4,
    name: 'Folding Knife',
    price: '$15.99',
    images: [knifeCard, knifeCard1],
    link: '/knife',
  },
  {
    id: 5,
    name: 'Power Bank',
    price: '$20.99',
    images: [batterypack, batterypack1],
    link: '/powerbank',
  },
  {
    id: 6,
    name: 'Hunting Card',
    price: '$15.99',
    images: [hunting, hunting1],
    link: '/hunting',
  },
  {
    id: 7,
    name: 'Utility Card',
    price: '$10.99',
    images: [utilityCard, utilityCard1],
    link: '/utility',
  },
  {
    id: 8,
    name: 'Bottle Opener',
    price: '$7.99',
    images: [bottle, bottle1],
    link: '/bottle',
  },
  {
    id: 9,
    name: 'Chapstick Holder',
    price: '$5.99',
    images: [chapstick, chapstick1],
    link: '/chapstick',
  }
];

const Shop = () => {
  const [activeImage, setActiveImage] = useState({});
  const [touchStartX, setTouchStartX] = useState({});
  const [touchEndX, setTouchEndX] = useState({});

  // Initialize the first image as active for each product
  useEffect(() => {
    const initialActiveImages = {};
    products.forEach((product) => {
      initialActiveImages[product.id] = 0;
    });
    setActiveImage(initialActiveImages);
  }, []);

  // Handle the start of a touch event for a given product
  const handleTouchStart = (e, productId) => {
    setTouchStartX((prev) => ({ ...prev, [productId]: e.targetTouches[0].clientX }));
  };

  // Update the touch end position as the user moves their finger
  const handleTouchMove = (e, productId) => {
    setTouchEndX((prev) => ({ ...prev, [productId]: e.targetTouches[0].clientX }));
  };

  // Determine the swipe direction when the touch event ends
  const handleTouchEnd = (productId, numImages) => {
    const start = touchStartX[productId];
    const end = touchEndX[productId];
    const threshold = 50; // Minimum swipe distance in px

    if (start && end) {
      const diff = start - end;
      if (diff > threshold) {
        // Swiped left, go to next image
        setActiveImage((prevState) => ({
          ...prevState,
          [productId]: (prevState[productId] + 1) % numImages,
        }));
      } else if (diff < -threshold) {
        // Swiped right, go to previous image
        setActiveImage((prevState) => ({
          ...prevState,
          [productId]: (prevState[productId] - 1 + numImages) % numImages,
        }));
      }
    }
    // Reset touch values for this product
    setTouchStartX((prev) => ({ ...prev, [productId]: null }));
    setTouchEndX((prev) => ({ ...prev, [productId]: null }));
  };

  const handleDotClick = (productId, index) => {
    setActiveImage((prevState) => ({
      ...prevState,
      [productId]: index,
    }));
  };

  return (
    <div className="shop-container20">
      <Header />
      <main className="shop-main20">
        <h1 className="shop-title20">Our Products</h1>
        <div className="product-container20">
          <div className="shop-grid20">
            {products.map((product) => (
              <div key={product.id} className="shop-card20">
                <a href={product.link} className="product-link20">
                  <img
                    src={product.images[activeImage[product.id] ?? 0]}
                    alt={product.name}
                    className="shop-image20"
                    onTouchStart={(e) => handleTouchStart(e, product.id)}
                    onTouchMove={(e) => handleTouchMove(e, product.id)}
                    onTouchEnd={() => handleTouchEnd(product.id, product.images.length)}
                  />
                </a>

                {/* Image Navigation Dots */}
                <div className="image-dots-container20">
                  <div className="image-dots20">
                    {product.images.map((_, index) => (
                      <FaCircle
                        key={index}
                        className={`dot20 ${activeImage[product.id] === index ? 'active-dot20' : ''}`}
                        onClick={() => handleDotClick(product.id, index)}
                      />
                    ))}
                  </div>
                </div>

                <div className="shop-card20-content">
                  <h3 className="shop-card20-title">{product.name}</h3>
                  <div className="shop-actions20">
                    <span className="product-price20">{product.price}</span>
                    <a href={product.link} className="shop-button20">
                      Shop
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Shop;

